// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useAcceptMintRequest2Step } from '@hooks/mutations/registry/mint/useAcceptMintRequest2Step';
import { useCancelMintRequest2Step } from '@hooks/mutations/registry/mint/useCancelMintRequest2Step';
import { useRejectMintRequest2Step } from '@hooks/mutations/registry/mint/useRejectMintRequest2Step';
import useRegistrarService from '@hooks/queries/registry/onboarding/useRegistrarService';
import { MintRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Mint';
import { ContractId } from '@daml/types';
import { RowNew } from '../../../../components/Table/types';

export const useGetMintChoices = (onSuccess?: () => void, selectedRow?: RowNew) => {
  const registrarService = useRegistrarService();

  const acceptMintRequest = useAcceptMintRequest2Step();
  const rejectMintRequest = useRejectMintRequest2Step();
  const cancelMintRequest = useCancelMintRequest2Step();

  const contractId = selectedRow?.contractId;
  const registrarServiceCid = registrarService?.data?.contractId;

  const onAccept = async () => {
    if (!contractId) {
      throw new Error('No row selected');
    }
    await acceptMintRequest({
      mintRequestId: contractId as ContractId<MintRequest>,
    });
    onSuccess?.();
  };

  const onCancel = async () => {
    if (!contractId) {
      throw new Error('No row selected');
    }
    await cancelMintRequest({
      mintRequestCid: contractId as ContractId<MintRequest>,
    });
    onSuccess?.();
  };

  const onReject = async (reason: string) => {
    if (!contractId) {
      throw new Error('No row selected');
    }
    if (!registrarServiceCid) {
      throw new Error('No registrar service');
    }
    await rejectMintRequest({
      mintRequestId: contractId as ContractId<MintRequest>,
      reason,
    });
    onSuccess?.();
  };

  return {
    onAccept,
    onReject,
    onCancel,
  };
};
